<template>
    <UFooter :ui="{ top: 'border-b border-default' }">
        <template #left>
            <p class="text-muted text-sm">© {{ new Date().getFullYear() }} Entrypoint</p>
        </template>
    </UFooter>
</template>

<script setup lang="ts"></script>
